import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="push-toggle"
export default class extends Controller {
  static targets = ["checkbox", "status", "supportNote"]

  async connect() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      this.disable("Push não suportado neste navegador.")
      return
    }
    try {
      this.registration = await navigator.serviceWorker.register("/push-service-worker.js", { scope: "/" })
      const sub = await this.registration.pushManager.getSubscription()
      this.checkboxTarget.checked = !!sub
      this.updateStatus(sub ? "Ativo neste navegador" : "Desativado")
    } catch (err) {
      this.disable(`Erro ao registrar service worker: ${err.message}`)
    }
  }

  async toggle(event) {
    event.preventDefault()
    const desired = event.target.checked
    try {
      if (desired) {
        await this.subscribe()
      } else {
        await this.unsubscribe()
      }
    } catch (err) {
      this.checkboxTarget.checked = !desired
      this.updateStatus(`Erro: ${err.message}`)
    }
  }

  async subscribe() {
    const permission = await Notification.requestPermission()
    if (permission !== "granted") {
      this.checkboxTarget.checked = false
      this.updateStatus("Permissão negada pelo navegador")
      return
    }
    const vapidKey = this.urlBase64ToUint8Array(this.vapidPublicKey())
    const subscription = await this.registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: vapidKey
    })
    const subJson = subscription.toJSON()
    await this.postJson("/preferencias/push_subscriptions", {
      subscription: {
        endpoint: subJson.endpoint,
        p256dh: subJson.keys.p256dh,
        auth: subJson.keys.auth,
        user_agent: navigator.userAgent
      }
    })
    this.updateStatus("Ativo neste navegador")
  }

  async unsubscribe() {
    const subscription = await this.registration.pushManager.getSubscription()
    if (!subscription) {
      this.updateStatus("Desativado")
      return
    }
    const endpoint = subscription.endpoint
    await subscription.unsubscribe()
    const endpointHash = await this.sha256(endpoint)
    await fetch(`/preferencias/push_subscriptions/${endpointHash}`, {
      method: "DELETE",
      headers: { "X-CSRF-Token": this.csrfToken() }
    })
    this.updateStatus("Desativado")
  }

  async postJson(url, body) {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken()
      },
      body: JSON.stringify(body)
    })
    if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
    return resp.json()
  }

  vapidPublicKey() {
    return document.querySelector('meta[name="vapid-public-key"]').content
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }

  urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
    const rawData = atob(base64)
    return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)))
  }

  async sha256(text) {
    const buf = new TextEncoder().encode(text)
    const hash = await crypto.subtle.digest("SHA-256", buf)
    return [...new Uint8Array(hash)].map(b => b.toString(16).padStart(2, "0")).join("")
  }

  updateStatus(msg) {
    if (this.hasStatusTarget) this.statusTarget.textContent = msg
  }

  disable(msg) {
    this.checkboxTarget.disabled = true
    if (this.hasSupportNoteTarget) this.supportNoteTarget.textContent = msg
  }
}
